/**
 * DAFNE App Configuration
 *
 * Application-wide configuration settings.
 */

// =============================================================================
// BETA TESTING FLAG
// =============================================================================

/**
 * When true, displays beta warnings on data entry and recommendations.
 * Set to false for production release.
 */
export const IS_BETA = true;

export const BETA_WARNING = {
  /** Short warning for inline display */
  SHORT: "Beta: Verify all calculations against OZDAFNE materials",

  /** Full warning for modals/alerts */
  FULL: `This app is in beta testing. All insulin dose suggestions and glucose predictions 
should be verified against your OZDAFNE course materials. If you notice any calculation 
errors, please report them so we can fix them promptly. Your safety is our priority.`,

  /** Feedback prompt */
  FEEDBACK: "Found an issue? Report it to help improve accuracy.",
} as const;
